import { motion } from "framer-motion";
import { Shield, Heart, Zap, MessageCircle } from "lucide-react";

const features = [
    {
        icon: Shield,
        title: "Privacy First",
        description: "Block your school district and hide during school hours. You control who sees you and when.",
    },
    {
        icon: Heart,
        title: "Emotional Safety",
        description: "A curated community of respectful partners who value your profession and understand your boundaries.",
    },
    {
        icon: Zap,
        title: "Lifestyle Matching",
        description: "We match based on energy levels and teaching schedules, not just photos. Find someone who gets the Sunday Scaries.",
    },
    {
        icon: MessageCircle,
        title: "Conversation Support",
        description: "AI-assisted icebreakers and replies to reduce emotional labor after a long day in the classroom.",
    },
];

export function WhyHallPassSection() {
    return (
        <section className="w-full bg-brand-background py-24 px-6 md:px-12 lg:px-24">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16 space-y-4">
                    <h2 className="text-3xl md:text-5xl font-bold text-brand-text">
                        Why Hall Pass?
                    </h2>
                    <p className="text-xl text-brand-muted max-w-2xl mx-auto">
                        We're building a space where educators can be themselves.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <motion.div
                            key={index}
                            className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center space-y-4"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                        >
                            <div className="w-16 h-16 bg-brand-primary/20 rounded-full flex items-center justify-center text-brand-dark mb-2">
                                <feature.icon size={32} strokeWidth={2} />
                            </div>
                            <h3 className="text-xl font-bold text-brand-dark">{feature.title}</h3>
                            <p className="text-muted-foreground leading-relaxed">
                                {feature.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
